import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import { postGenerateReportForClientFromSelectedRecords } from 'scenes/WorkDemo/services/postGenerateReportForClientFromSelectedRecords.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectSelectedRecordsIds } from 'store/records/selectors/records-base.selectors';
import { selectReportGeneratedFromMode } from 'store/reports/selectors/reports.selectors';
import {
  selectHighestLevelProjectFromSelectedProjects,
  selectWorkCalendarFilteredRecords,
} from '../../selectors/workSelectorsDemo';

export const generateReportForClientFromSelectedRecords = createAsyncThunk(
  'workCalendar/generateReportForClientFromSelectedRecords',
  async (dialogSettings, { getState }) => {
    const state = getState();

    const selectedProjectId = selectSelectedProjectId(state);

    const selectedRecordIds = selectSelectedRecordsIds(state);

    const reportGeneratedFromMode = selectReportGeneratedFromMode(state);

    const allWorkCalendarFilteredRecords =
      selectWorkCalendarFilteredRecords(state);

    const projectToUseInReport =
      selectHighestLevelProjectFromSelectedProjects(state);

    const {
      selectedReportType,
      workStartTime,
      workEndTime,
      fromDate,
      toDate,
      language,
      filetype,
      workHourType,
      includeWorkerNames,
      includeUnapprovedRecords,
    } = dialogSettings;

    // By default only approved records are included; the user can opt in to
    // also include unapproved records via the dialog checkbox.
    const recordsForReport = includeUnapprovedRecords
      ? allWorkCalendarFilteredRecords
      : allWorkCalendarFilteredRecords.filter(
          (record) => record.approved === true
        );

    const allWorkCalendarFilteredRecordsIds = recordsForReport.map(
      (record) => record.id
    );

    const recordIdsToGenerateReportFrom =
      reportGeneratedFromMode === 'SELECTED'
        ? selectedRecordIds
        : allWorkCalendarFilteredRecordsIds;

    const utcOffset = moment.parseZone(moment().format()).format('Z');

    const generationParams = {
      fromDate,
      toDate,
      selectedReportType,
      workStartTime,
      workEndTime,
      language,
      filetype,
      utcOffset,
      workHourType,
      includeWorkerNames,
    };

    const report = await postGenerateReportForClientFromSelectedRecords(
      selectedProjectId,
      recordIdsToGenerateReportFrom,
      generationParams,
      projectToUseInReport?.id
    );

    return report;
  }
);
